import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReactGA from 'react-ga4';
import MainLayout from 'Components/MainLayout';
import SignupFormComponent from './SignupFormComponent';
import { useDispatch, useSelector } from 'react-redux';
import * as Apis from 'Api';
import { NotificationManager } from 'react-notifications';
import { login } from 'Store/Actions';
import EnterpriseComponent from './EnterpriseComponent';

function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLogin } = useSelector((state) => state.authUser);
  const [searchParams, setSearchParams] = useSearchParams();
  const [fromRanzcr, setFromRanzcr] = useState(false);
  const showEnterprise = searchParams.get('step') === 'enterprise';

  useEffect(() => {
    const referer = document.referrer;
    let isFromRanzcr = false;
    if (referer) {
      const url = new URL(referer);
      isFromRanzcr = url.hostname.endsWith('ranzcr.com');
    }
    if (isFromRanzcr) {
      setFromRanzcr(isFromRanzcr);
    }
  }, []);

  useEffect(() => {
    if (isLogin && searchParams.get('step') !== 'enterprise') {
      navigate('/', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEnterpriseCodeSubmit = (code) => {
    Apis.enterpriseApplyTestSet(code)
      .then((resp) => {
        NotificationManager.success(`The enterprise code was applied.`);
        navigate('/');
      })
      .catch((e) => {
        NotificationManager.error(
          e.response ? e.response.data.error.message : e.message,
        );
      });
  };

  const onSignUp = (info, hasEnterpriseCode) => {
    Apis.signUp(info)
      .then((result) => {
        ReactGA.event('sign_up');
        NotificationManager.success('Register succeeded.');
        return Apis.login(info.email, info.password);
      })
      .then((result) => {
        dispatch(
          login(
            result.userId,
            result.userName,
            result.userEmail,
            result.id,
            navigate,
            null,
          ),
        );
        if (hasEnterpriseCode) {
          setSearchParams({ step: 'enterprise' });
        } else {
          navigate('/');
        }
      })
      .catch((e) => {
        NotificationManager.error(
          e.response ? e.response.data.error.message : e.message,
        );
      });
  };

  if (showEnterprise) {
    return (
      <MainLayout>
        <EnterpriseComponent onSubmit={onEnterpriseCodeSubmit} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <SignupFormComponent onComplete={onSignUp} fromRanzcr={fromRanzcr} />
    </MainLayout>
  );
}

export default Index;
